import { Component, Input } from '@angular/core';
import { ParagraphModel } from '../../../../api/models';
import { FlexModule } from '@angular/flex-layout';
import { TranscriptSentimentIconComponent } from '../transcript-sentiment-icon/transcript-sentiment-icon.component';

@Component({
    selector: 'transcript-paragraph',
    templateUrl: './transcript-paragraph.component.html',
    styleUrls: ['./transcript-paragraph.component.scss'],
    standalone: true,
    imports: [FlexModule, TranscriptSentimentIconComponent],
})
export class TranscriptParagraphComponent {
  @Input({ required: true })
  paragraph: ParagraphModel;

  get speakerLabel(): string {
    return this.paragraph.speaker !== undefined ? `Speaker ${this.paragraph.speaker}:` : '';
  }

  get paragraphText(): string {
    return this.paragraph.sentences?.map(item => item.text).join(' ');
  }
}
